import React, { Component, ReactNode } from 'react';

import { Button } from 'antd';
import cx from 'classnames';
import Icon from '@ant-design/icons';

import { AddMinutesToCurrentTerm } from './AddMinutesToCurrentTerm';
import { CreateNewTerm } from './CreateNewTerm';
import { ReactComponent as SxPlus } from '../../../../assets/sightx-icons/svg/sx-plus-circle.svg';
import { ReactComponent as SxRefresh } from '../../../../assets/sightx-icons/svg/sx-refresh.svg';

import styles from './index.module.scss';

enum Mode {
  NoDataDefault,
  HasDataDefault,
  AddMinutesToCurrentTerm,
  StartNewTerm,
}

interface IExternalProps {
  accountId: string;
  actionStarted?: () => void;
  actionSuceeded?: () => void;
  actionCancelled?: () => void;
  disabled?: boolean;
  hasData: boolean;
}

interface IState {
  mode: Mode;
}

type IProps = IExternalProps;

class AddMinutesOrStartTerm extends Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      mode: props.hasData ? Mode.HasDataDefault : Mode.NoDataDefault
    };

    this.handleActionCancelled = this.handleActionCancelled.bind(this);
    this.handleActionStarted = this.handleActionStarted.bind(this);
    this.handleAddMinutesToCurrentTerm = this.handleAddMinutesToCurrentTerm.bind(this);
    this.handleAddMinutesToTermSucceeded = this.handleAddMinutesToTermSucceeded.bind(this);
    this.handleCancelAddMinutesToTerm = this.handleCancelAddMinutesToTerm.bind(this);
    this.handleCancelCreateNewTerm = this.handleCancelCreateNewTerm.bind(this);
    this.handleCreateNewTermSucceeded = this.handleCreateNewTermSucceeded.bind(this);
    this.handleStartNewTerm = this.handleStartNewTerm.bind(this);
  }

  private handleCancelCreateNewTerm() {
    if(this.props.hasData) {
      this.setState({ mode: Mode.HasDataDefault });
    } else {
      this.setState({ mode: Mode.NoDataDefault });
    }
    this.handleActionCancelled();
  }

  private handleActionStarted() {
    this.props.actionStarted?.();
  }

  private handleActionCancelled() {
    this.props.actionCancelled?.();
  }

  private handleAddMinutesToCurrentTerm() {
    if(this.props.disabled) {
      return;
    }
    this.setState({ mode: Mode.AddMinutesToCurrentTerm });
    this.handleActionStarted();
  }

  private handleCancelAddMinutesToTerm() {
    this.handleCancelCreateNewTerm();
    this.handleActionCancelled();
  }

  private handleAddMinutesToTermSucceeded() {
    this.props.actionSuceeded?.();
    this.handleCancelCreateNewTerm();
  }

  private handleCreateNewTermSucceeded() {
    this.props.actionSuceeded?.();
    this.handleCancelCreateNewTerm();
  }

  private handleStartNewTerm() {
    if(this.props.disabled) {
      return;
    }
    this.setState({ mode: Mode.StartNewTerm });
    this.handleActionStarted();
  }

  private renderStartNewTermActionComponent() {
    return (
      <CreateNewTerm disabled={!!this.props.disabled} accountId={this.props.accountId} onCancel={this.handleCancelCreateNewTerm} onSucceeded={this.handleCreateNewTermSucceeded} />
    );
  }

  private renderAddMinutesToCurrentTermActionComponent() {
    return (
      <AddMinutesToCurrentTerm accountId={this.props.accountId} onCancel={this.handleCancelAddMinutesToTerm} onSucceeded={this.handleAddMinutesToTermSucceeded} />
    );
  }

  private renderAddOrStartNewSelection() {
    return (
      <div className={styles.addOrNewContainer}>
        <Button disabled={!!this.props.disabled} className={styles.cta} type='default' onClick={this.handleAddMinutesToCurrentTerm}>
          <Icon className={cx(styles.icon,styles.addMinutesIcon)} component={SxPlus} />
          <div>Add minutes to current term</div>
        </Button>
        <Button disabled={!!this.props.disabled} className={styles.cta} type='primary' onClick={this.handleStartNewTerm}>
          <Icon className={cx(styles.icon, styles.startTermIcon)} component={SxRefresh} />
          <div>Start new term</div>
        </Button>
      </div>
    );
  }

  private selectAndRender() {
    const { mode } = this.state;

    switch(mode) {
    case Mode.NoDataDefault:
    case Mode.StartNewTerm:
      return this.renderStartNewTermActionComponent();
    case Mode.HasDataDefault:
      return this.renderAddOrStartNewSelection();
    case Mode.AddMinutesToCurrentTerm:
      return this.renderAddMinutesToCurrentTermActionComponent();
    default:
      return this.renderStartNewTermActionComponent();
    }
  }

  render(): ReactNode {
    return this.selectAndRender();
  }
}

const AddMinutesOrStartTermPlaceHolder: React.FC = () => {
  return (
    <div className={styles.addOrNewContainer}>
      <div className={styles.placeholderContents}>
        <Button type='default'>
          Start new term
        </Button>
        <Button type='primary'>
          Add minutes to current term
        </Button>
      </div>
    </div>
  );
};

export { AddMinutesOrStartTerm, AddMinutesOrStartTermPlaceHolder };
